<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم والإدخال (تختفي عند الطباعة) -->
    <div class="card shadow-sm border-top-danger mb-4 no-print">
      <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 class="fw-bold text-danger mb-0">
          <i class="fas fa-user-times ms-2"></i> تسجيل غياب الطلاب (لجنة السير)
        </h5>
        <div v-if="loadingInit" class="spinner-border spinner-border-sm text-secondary"></div>
      </div>
      
      <div class="card-body">
        
        <!-- اختيار المادة -->
        <div class="row g-3 mb-4 align-items-end">
          <div class="col-md-6">
            <label class="form-label fw-bold">المادة الامتحانية</label>
            <select v-model="form.subject_id" @change="fetchAbsentees" class="form-select form-select-lg">
              <option value="">-- اختر المادة --</option>
              <option v-for="sub in subjects" :key="sub.id" :value="sub.id">{{ sub.name }}</option>
            </select>
          </div>
          
          <div class="col-md-6">
             <div class="alert alert-info py-2 mb-0 border-info small">
               <i class="fas fa-info-circle ms-1"></i>
               لجنة: <strong>{{ committeeName }}</strong> | إجمالي الطلاب: <strong>{{ stats.total }}</strong>
             </div>
          </div>
        </div>

        <hr v-if="form.subject_id">

        <!-- إدخال رقم الجلوس -->
       <div v-if="form.subject_id" class="row justify-content-center">
  <div class="col-md-8 col-lg-6"> <!-- تعديل العرض ليناسب الشاشات المختلفة -->
    
    <form @submit.prevent="addAbsentStudent">
      <div class="row g-2"> <!-- g-2 مسافة صغيرة بين العناصر -->
        
        <!-- 1. حقل الإدخال مع العنوان -->
        <div class="col-12 col-md-8">
          <div class="input-group input-group-lg h-100">
            <span class="input-group-text bg-danger text-white">
              <i class="fas fa-chair d-md-none"></i> <!-- أيقونة للموبايل لتقليل المساحة -->
              <span class="d-none d-md-inline">رقم الجلوس</span> <!-- نص للكمبيوتر -->
            </span>
            <input 
              ref="seatInput"
              v-model="form.Seating_No" 
              type="number" 
              class="form-control text-center fw-bold font-monospace fs-4" 
              placeholder="رقم الجلوس"
              :disabled="submitting"
              inputmode="numeric"
              autofocus
            >
          </div>
        </div>

        <!-- 2. زر التسجيل (منفصل) -->
        <div class="col-12 col-md-4">
          <button 
            class="btn btn-danger btn-lg w-100 h-100 fw-bold shadow-sm" 
            type="submit" 
            :disabled="submitting || !form.Seating_No"
          >
            <span v-if="submitting" class="spinner-border spinner-border-sm"></span>
            <span v-else>
              <i class="fas fa-plus-circle ms-1"></i> تسجيل
            </span>
          </button>
        </div>

      </div>
    </form>

    <!-- رسائل التنبيه -->
    <div v-if="message" :class="`alert mt-3 py-2 text-center alert-${messageType} fade show shadow-sm`">
      <i :class="messageIcon"></i> {{ message }}
    </div>
    
  </div>
</div>

      </div>
    </div>

    <!-- 2. جدول الطلاب الغائبين (للمراجعة والطباعة) -->
    <!-- يظهر فقط عند اختيار مادة -->
    <div v-if="form.subject_id" class="card shadow-sm border-0 print-section" id="printMe">
    <div class="card-body p-3 p-md-5"> <!-- حواف صغيرة للموبايل وكبيرة للكمبيوتر -->
      
      <!-- 1. ترويسة التقرير (رسمية) -->
      <div class="report-header mb-4 border-bottom pb-3">
        <!-- استخدام g-3 لإضافة مسافات، وتحويل الأعمدة لتكون متجاوبة -->
        <div class="row g-3 align-items-center text-center">
          
          <!-- الجزء الأيمن -->
          <div class="col-12 col-md-4 text-md-end order-2 order-md-1">
            <h6 class="mb-1 fw-bold">محافظة: شمال سيناء</h6>
            <h6 class="mb-1 fw-bold">مديرية التربية والتعليم</h6>
            <h6 class="mb-0 fw-bold">لجنة: {{ committeeName }}</h6>
          </div>

          <!-- الجزء الأوسط (العنوان) -->
          <div class="col-12 col-md-4 order-1 order-md-2">
            <h4 class="fw-bold text-decoration-underline mb-2">مذكرة غياب طلاب</h4>
            <h5 class="badge bg-light text-dark border border-dark px-3 py-2 fs-6">
              مادة: {{ getSubjectName }}
            </h5>
          </div>

          <!-- الجزء الأيسر -->
          <div class="col-12 col-md-4 text-md-start order-3 order-md-3">
            <h6 class="mb-1 fw-bold">العام الدراسي: 2025 / 2026</h6>
            <h6 class="mb-1">تاريخ اليوم: {{ todayDate }}</h6>
            <h6 class="mb-0">لجنة رقم : [111]</h6>
          </div>
        </div>
      </div>

      <!-- 2. إحصائيات سريعة -->
      <div class="row g-0 text-center mb-3 stats-bar fw-bold fs-5 border rounded overflow-hidden">
        <div class="col-4 border-end py-2 bg-light">
          <small class="d-block d-md-none fs-6 fw-normal">المقيدين</small> <!-- نص صغير للموبايل -->
          <span class="d-none d-md-inline">المقيدين: </span>
          {{ stats.total }}
        </div>
        <div class="col-4 border-end py-2 bg-light">
          <small class="d-block d-md-none fs-6 fw-normal">الحضور</small>
          <span class="d-none d-md-inline">الحضور: </span>
          {{ stats.total - absentees.length }}
        </div>
        <div class="col-4 py-2 bg-warning-subtle text-danger">
          <small class="d-block d-md-none fs-6 fw-normal">الغياب</small>
          <span class="d-none d-md-inline">الغياب: </span>
          {{ absentees.length }}
        </div>
      </div>

      <!-- 3. جدول الغياب -->
      <div class="table-responsive">
        <table class="table table-bordered border-dark text-center align-middle mb-0">
          <thead class="bg-light">
            <tr>
              <th style="width: 10%">م</th>
              <th style="width: 25%">رقم الجلوس</th>
              <th style="width: 45%">اسم الطالب</th>
              <!-- إخفاء عمود العمليات في الطباعة -->
              <th style="width: 20%" class="d-print-none">العمليات</th>
              <!-- إظهار عمود الملاحظات فقط في الطباعة -->
              <th style="width: 20%" class="d-none d-print-table-cell">ملاحظات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(student, index) in absentees" :key="student.id">
              <td>{{ index + 1 }}</td>
              <td class="fw-bold fs-5 font-monospace">{{ student.Seating_No }}</td>
              <td class="text-end pe-3 fw-bold">{{ student.Arabic_Name }}</td>
              
              <!-- زر الحذف (يظهر للشاشة فقط) -->
              <td class="d-print-none">
                <button 
                  @click="removeAbsent(student.id)" 
                  class="btn btn-sm btn-outline-danger w-100" 
                >
                  <i class="fas fa-trash-alt"></i> <span class="d-none d-md-inline">حذف</span>
                </button>
              </td>

              <!-- خانة غائب (تظهر للطباعة فقط) -->
              <td class="d-none d-print-table-cell fw-bold bg-light">غائب</td>
            </tr>
            <tr v-if="absentees.length === 0">
              <td colspan="5" class="py-4 text-muted">لا يوجد غياب مسجل لهذه المادة حتى الآن</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 4. التذييل والتوقيعات -->
      <div class="report-footer mt-5 pt-4">
        <p class="text-start fw-bold mb-4 lh-lg border p-2 rounded d-inline-block bg-light-subtle">
          <i class="fas fa-check-square me-2"></i>
          أقر أنا رئيس اللجنة بأن الطلاب الموضحة أسماؤهم بعاليه قد تغيبوا عن امتحان مادة ( {{ getSubjectName }} )،
          وأن عدد أوراق الإجابة الفعلية الموجودة بالمظروف هو ( {{ stats.total - absentees.length }} ) ورقة.
        </p>
        
        <div class="row text-center mt-4 gy-4"> <!-- gy-4 مسافة رأسية عند التكديس في الموبايل -->
          <div class="col-4"> <!-- يبقى 3 أعمدة حتى في الموبايل للتوقيعات -->
            <h6 class="fw-bold small">مراقب الدور</h6>
            <p class="mt-4 text-muted">................</p>
          </div>
          <div class="col-4">
            <h6 class="fw-bold small">المراقب الأول</h6>
            <p class="mt-4 text-muted">................</p>
          </div>
          <div class="col-4">
            <h6 class="fw-bold small">رئيس اللجنة</h6>
            <p class="mt-4 text-muted">................</p>
          </div>
        </div>
      </div>

    </div>
    
    <!-- زر الطباعة العائم -->
    <div class="card-footer bg-white text-start no-print py-3">
      <button @click="print" class="btn btn-dark px-4 w-100 w-md-auto" :disabled="absentees.length === 0">
        <i class="fas fa-print ms-2"></i> طباعة التقرير
      </button>
    </div>

  </div>

  </div>
</template>

<script>
// تأكد من ضبط إعدادات axios لديك

import api from '@/api/axios';

export default {
  name: "CommitteeAbsenceRecorder",
  data() {
    return {
      // حالة التحميل
      loadingInit: false,
      loadingTable: false,
      submitting: false,

      // البيانات الأساسية
      committeeName: "جاري التحميل...",
      todayDate: new Date().toLocaleDateString('ar-EG'),
      subjects: [],
      stats: { total: 0 },

      // بيانات المدخلات
      form: {
        subject_id: "",
        Seating_No: ""
      },
      
      // قائمة الغياب
      absentees: [],

      // رسائل المستخدم
      message: "",
      messageType: "success"
    };
  },
  computed: {
    // جلب اسم المادة المختارة للعرض في التقرير
    getSubjectName() {
      const subject = this.subjects.find(s => s.id === this.form.subject_id);
      return subject ? subject.name : '';
    },
    messageIcon() {
        return this.messageType === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-triangle';
    }
  },
  mounted() {
    this.fetchInitData();
  },
  methods: {
    // 1. جلب البيانات الأولية (المواد واسم اللجنة)
    async fetchInitData() {
      this.loadingInit = true;
      try {
        const res = await api.get('/committee/init-data');
        this.subjects = res.data.subjects;
        this.committeeName = res.data.committee_name;
        this.stats.total = res.data.total_students;
      } catch (error) {
        console.error("Error init", error);
        alert("فشل في تحميل بيانات اللجنة");
      } finally {
        this.loadingInit = false;
      }
    },

    // 2. جلب جدول الغياب عند تغيير المادة
    async fetchAbsentees() {
      if (!this.form.subject_id) {
          this.absentees = [];
          return;
      }
      
      this.loadingTable = true;
      this.message = ""; // مسح الرسائل القديمة

      try {
        const res = await api.get('/committee/absence', {
            params: { subject_id: this.form.subject_id }
        });
        this.absentees = res.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingTable = false;
      }
    },

    // 3. إضافة غياب جديد
    async addAbsentStudent() {
      if (!this.form.Seating_No) return;

      this.submitting = true;
      this.message = "";

      try {
        const res = await api.post('/committee/absence', {
            subject_id: this.form.subject_id,
            Seating_No: this.form.Seating_No
        });

        // إضافة الطالب للقائمة محلياً (لعدم إعادة تحميل الجدول)
        this.absentees.push(res.data.student);
        
        // رسالة نجاح
        this.message = "تم تسجيل الغياب بنجاح";
        this.messageType = "success";
        
        // تفريغ الحقل والتركيز عليه للإدخال التالي
        this.form.Seating_No = "";
        this.$nextTick(() => {
            this.$refs.seatInput.focus();
        });

      } catch (error) {
        if (error.response) {
            // رسائل الخطأ من الباك اند (404 أو 422)
            this.message = error.response.data.message; 
            this.messageType = "danger";
        } else {
            this.message = "حدث خطأ في الاتصال";
            this.messageType = "danger";
        }
      } finally {
        this.submitting = false;
      }
    },

    // 4. حذف الغياب
    async removeAbsent(id) {
      if(!confirm("هل أنت متأكد من حذف هذا الطالب من كشف الغياب؟")) return;

      try {
        await api.delete(`/committee/absence/${id}`);
        // تحديث القائمة محلياً
        this.absentees = this.absentees.filter(item => item.id !== id);
      } catch (error) {
        alert("فشل حذف السجل");
      }
    },

    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },
  }
};
</script>

<style scoped>
/* حدود ملونة */
.border-top-danger { border-top: 4px solid #dc3545; }
.bg-warning-subtle { background-color: #fff3cd; }

/* تنسيق الخطوط */
.font-monospace { font-family: 'Courier New', Courier, monospace; letter-spacing: 1px; }

/* إخفاء عناصر "فقط للطباعة" في وضع الشاشة */
.only-print { display: none; }

/* تنسيقات الطباعة */
@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  
  body * {
    visibility: hidden;
  }
  
  .no-print {
    display: none !important;
  }

  /* إظهار منطقة التقرير */
  .print-section, .print-section * {
    visibility: visible;
  }

  .print-section {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    border: none !important;
    box-shadow: none !important;
  }

  /* تحسين الجدول */
  .table-bordered th, 
  .table-bordered td {
    border: 1px solid #000 !important;
    padding: 8px !important;
  }

  /* التعامل مع زر الحذف وعمود الملاحظات */
  th:nth-child(4), td:nth-child(4) { /* إخفاء عمود الحذف */
      display: none;
  }
  
  .only-print { /* إظهار كلمة غائب بدلاً من زر الحذف */
      display: table-cell !important;
      border: 1px solid #000 !important;
  }

  /* إجبار المتصفح على طباعة الخلفيات */
  .bg-light, .bg-warning-subtle, .badge {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>